import { formatLocalDateTime } from '../../utils/formatTimestamp';

export const EMAIL_ACTION_LABELS = {
  user_signup: 'New user signup',
  register_welcome: 'Register welcome (web form)',
  user_created: 'User account created',
  candidate_onboarded: 'Candidate onboarded',
  job_match_found: 'Job match found',
  timesheet_submitted: 'Timesheet submitted',
  timesheet_approved: 'Timesheet approved',
  timesheet_rejected: 'Timesheet rejected',
};

export function formatEmailDate(value) {
  return formatLocalDateTime(value);
}

export function emailStatusClass(status) {
  if (status === 'sent') return 'success';
  if (status === 'pending') return 'info';
  if (status === 'failed') return 'danger';
  if (status === 'skipped') return 'muted';
  return 'muted';
}

export function actionLabel(actionId) {
  return EMAIL_ACTION_LABELS[actionId] || actionId || '—';
}
